const theme = {
  primary: '#3982c1', // blue
  secondary: '#FF69B4', // hotpink
  bacground: '#c4f2ff', // light blue
  onPrimary: '#ffffff',
  onSecondary: '#ffffff',
  onBackground: '#000000'
};

export default theme;
